/* if adding a new flag, update use-record-all-flags.ts */

"use client";

import { usePostHogFlag } from "../use-posthog-flag";

export function useAdditionalEmbeddedWalletAccountsEnabled() {
  return usePostHogFlag("enable_additional_embedded_wallet_accounts");
}
